import styles from "@/asserts/styles/formSection.module.less";
import ModalSectionHeader from "@/components/ui/ModalSectionHeader";
import { Col, Form, Row, Select, Space } from "antd";
import type { PurchaseContractFormValues } from "../type";

import {
  CONTRACT_CATEGORY_OPTIONS,
  CONTRACT_DESC_OPTIONS,
  CONTRACT_CATEGORY_OPTIONS_PO,
  CONTRACT_SUB_CATEGORY_OPTIONS,
} from "@/constants";
import { useTranslation } from "react-i18next";

/**
 * 合同审查信息
 */
export function ContractReviewFormFields() {
  const { t } = useTranslation("contractManagement");
  const form = Form.useFormInstance<PurchaseContractFormValues>();
  const materialType = Form.useWatch("materialType", form);

  // 根据 materialType 过滤合同子类别选项
  const filteredContractSubCategoryOptions =
    CONTRACT_SUB_CATEGORY_OPTIONS.filter((option) =>
      materialType ? option.value.startsWith(`${materialType}_`) : true,
    );

  // 根据 materialType 过滤合同描述选项
  const filteredContractDescOptions =
    materialType === "C0"
      ? CONTRACT_DESC_OPTIONS.filter((option) => option.value === "其他")
      : CONTRACT_DESC_OPTIONS;

  const showContractCategory = materialType === "C1";

  return (
    <div className={styles.formSection}>
      <ModalSectionHeader title={t("合同审查信息")} />

      <div className={styles.sectionBody}>
        <Row gutter={49}>
          <Col span={8}>
            <Form.Item<PurchaseContractFormValues>
              name="materialType"
              label={t("合同类别")}
              rules={[
                {
                  required: true,
                  message: t("请选择合同类别"),
                },
              ]}
            >
              <Space.Compact style={{ width: "100%" }}>
                <Form.Item name="materialType" noStyle>
                  <Select
                    style={{ width: showContractCategory ? "60%" : "100%" }}
                    placeholder={t("请选择")}
                    options={CONTRACT_CATEGORY_OPTIONS}
                    onChange={(materialType) => {
                      if (materialType !== "C1") {
                        form.setFieldValue("contractCategory", undefined);
                      }

                      // 当 materialType 变化时，重置 contractSubCategory 的值
                      form.setFieldValue("contractSubCategory", undefined);

                      // 当 materialType 变化时，如果当前 contractDescription 值不在过滤后的选项中，重置 contractDescription 的值
                      const currentContractDesc = form.getFieldValue(
                        "contractDescription",
                      );
                      if (
                        (currentContractDesc &&
                          !filteredContractDescOptions.some(
                            (option) => option.value === currentContractDesc,
                          )) ||
                        materialType === "C0"
                      ) {
                        form.setFieldValue("contractDescription", undefined);
                      }
                    }}
                  />
                </Form.Item>
                {showContractCategory && (
                  <Form.Item
                    name="contractCategory"
                    noStyle
                    rules={[
                      {
                        required: true,
                        message: t("请选择合同类别"),
                      },
                    ]}
                  >
                    <Select
                      style={{ width: "40%" }}
                      options={CONTRACT_CATEGORY_OPTIONS_PO}
                      placeholder={t("请选择")}
                    />
                  </Form.Item>
                )}
              </Space.Compact>
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item<PurchaseContractFormValues>
              name="contractSubCategory"
              label={t("合同子类别")}
              rules={[
                {
                  required: true,
                  message: t("请选择合同子类别"),
                },
              ]}
            >
              <Select
                placeholder={t("请选择")}
                options={filteredContractSubCategoryOptions}
              />
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item<PurchaseContractFormValues>
              name="contractDescription"
              label={t("合同描述")}
              rules={[
                {
                  required: true,
                  message: t("请输入合同描述"),
                },
              ]}
            >
              <Select
                placeholder={t("请选择")}
                options={filteredContractDescOptions}
              />
            </Form.Item>
          </Col>
        </Row>
      </div>
    </div>
  );
}
